import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'
//import actions from './actions';
//import getters from './getters';
//import mutations from './mutations';

Vue.use(Vuex);

function builder() {
  return new Vuex.Store({
    plugins: [createPersistedState({
        storage: window.sessionStorage,
    })],
    state: {
      info: [{}],
      point: -1,
      frontLang: window.navigator.language.slice(0,2),
      userName: '',
      curUserName: '',
      curUserType: 't',
      curUserCompanyName: '',
      curUserHomeUrl: '',
      curPos: {lat: 0, lng: 0, zoom: 10},
      curBounds: {minLat: 0, minLng: 0, maxLat: 0, maxLng: 0 },
      //avatarUrl: '',
      avatarKey: 0,
      placeName: '',
      tripName: '',
      itemType: '',
      intLoc: '',
      curLayer: 0,
      inRu: 0,
      mapOn: false,
      accept: '',
      app: false,
      progress: 0,
      redir: false,
      compareBox: {userName: '', outingName: ''}
    },
    getters: {
        getInfo: state => {
            //if(state.info.length==0) return null;
            if(state.point==0) return null
            else {
                let repl = state.info[state.point];
                /*
                console.log('getInfo num '+state.info.length);
                console.log('getInfo point '+state.point);
                console.log('getInfo userName '+repl.userName);
                */
                return repl;
            }
        },
        getPoint: state => { return state.point; },
        getFrontLang: state => { return state.frontLang; },
        getUserName: state => { return state.userName; },
        getCurUserName: state => { return state.curUserName; },
        getCurUserCompanyName: state => { return state.curUserCompanyName; },
        getCurUserHomeUrl: state => { return state.curUserHomeUrl; },
        getCurUserType: state => { return state.curUserType; },
        /*
        getCurPos: state => { return state.curPos.filter(curPos =>
            { curPos.lat, curPos.lng, curPos.zoom } ) },
        */
        getCurPos: state => {
            return { lat: state.curPos.lat, lng: state.curPos.lng, zoom: state.curPos.zoom }
        },
        getCurBounds: state => { return state.curBounds; },
        //getAvatarUrl: state => { return state.avatarUrl; },
        getAvatarKey: state => { return state.avatarKey; },
        getPlaceName: state => { return state.placeName; },
        getTripName: state => { return state.tripName; },
        getItemType: state => { return state.itemType; },
        getIntLoc: state => { return state.intLoc; },
        getCurLayer: state => {
            //console.log("getter of lay "+state.curLayer);
            if((typeof state.curLayer) == 'undefined') return 0;
            else return state.curLayer;
        },
        getInRu: state => { return state.inRu; },
        mapOn: state => { return state.mapOn; },
        getAccept: state => { return state.accept; },
        getApp: state => { return state.app; },
        progress: state => { return state.placeName; },
        redir: state => { return state.redir; },
        getCompareBox: state => { return state.compareBox; },
    },
    mutations: {
        /*
        go(state, dir) {
          let res = state.point + dir;
          if(res <0)  state.point = 0;
          else if(res >= state.info.length) state.point = state.info.length-1;
          else state.point = res;
        },
        */
        setInfo(state, item) {
            state.info[state.point] = {};
            for (let elem in item) {
                 if(typeof item[elem]!= undefined) state.info[state.point][elem] = item[elem];
            }
        },
        setPoint(state, dir) {
            //console.log('setPoint '+state.point, dir);
            state.point = state.point+dir;
        },
        chFrontLang(state) {
            if(state.frontLang==='ru') state.frontLang='en';
            else state.frontLang='ru';
        },
        setUserName(state, userName) {
            state.userName = userName;
        },
        setCurUserName(state, curUserName) {
            state.curUserName = curUserName;
        },
        setCurUserType(state, curUserType) {
            state.curUserType = curUserType;
        },
        setCurUserCompanyName(state, curUserCompanyName) {
            state.curUserCompanyName = curUserCompanyName;
        },
        setCurUserHomeUrl(state, curUserHomeUrl) {
            state.curUserHomeUrl = curUserHomeUrl;
        },
        setCurPos(state, curPos) {
            state.curPos.lat = curPos.lat;
            state.curPos.lng = curPos.lng;
            state.curPos.zoom = curPos.zoom;
        },
        setCurBounds(state, curBounds) {
//            console.log(curBounds[0][0], curBounds[0][1], curBounds[1][0], curBounds[1][1]);
            state.curBounds = curBounds;
        },
        /*
        setAvatarUrl(state, avatarUrl) {
            alert(avatarUrl);
            state.avatarUrl = avatarUrl;
        },
        */
        incAvatarKey(state) {
            state.avatarKey++;
        },
        setPlaceName(state, placeName) {
            state.placeName = placeName;
        },
        setTripName(state, tripName) {
            state.tripName = tripName;
        },
        setItemType(state, itemType) {
            state.itemTypeName = itemType;
        },
        setIntLoc(state, intLoc) {
            state.intLoc = intLoc;
        },
        setCurLayer(state, curLayer) {
            if((typeof curLayer) == 'undefined') state.curLayer = 0;
            else state.curLayer = curLayer;
        },
        setMapOn(state, mapOn) {
            state.mapOn = mapOn;
        },
        setInRu(state, inRu) {
            state.inRu = inRu;
        },
        setAccept(state, accept) {
            state.accept = accept;
        },
        setApp(state, app) {
            state.app = app;
        },
        setProgress(state, progress) {
            state.progress = progress;
        },
        setRedir(state, redir) {
            state.redir = redir;
        },
        setCompareBox(state, compareBox) {
            state.compareBox.userName = compareBox.userName;
            state.compareBox.outingName = compareBox.outingName;
        }
    },
    actions: {
        setCurLayer({ commit }, curLayer) {
            //console.log("action set inRu "+curLayer);
            commit('setCurLayer', curLayer);
        }
    }
  });
}

export default builder;
